import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=30c88ed6&scoped=true&"
import script from "./taskList.vue?vue&type=script&lang=js&"
export * from "./taskList.vue?vue&type=script&lang=js&"
import style0 from "./taskList.vue?vue&type=style&index=0&id=30c88ed6&prod&scoped=true&lang=css&"
import style1 from "./taskList.vue?vue&type=style&index=1&id=30c88ed6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c88ed6",
  null
  
)

export default component.exports